import { createContext, Dispatch, ReactNode, useContext, useReducer } from 'react';

interface GlobalState {
  promiseCount: number;
  verbiageCount: number;
  avgUniqueWordsPerHundred: number;
  avgWordsPerSentence: number;
  mainTheme: string;
  mainKeyword: string;
}

type Action =
  | { type: 'SET_PROMISE_COUNT'; payload: number }
  | { type: 'SET_VERBIAGE_COUNT'; payload: number }
  | { type: 'SET_AVG_UNIQUE_WORDS'; payload: number }
  | { type: 'SET_AVG_WORDS_PER_SENTENCE'; payload: number }
  | { type: 'SET_MAIN_THEME'; payload: string }
  | { type: 'SET_MAIN_KEYWORD'; payload: string };

const initialState: GlobalState = {
  promiseCount: 0,
  verbiageCount: 0,
  avgUniqueWordsPerHundred: 0,
  avgWordsPerSentence: 0,
  mainTheme: '',
  mainKeyword: '',
};

function globalStateReducer(state: GlobalState, action: Action): GlobalState {
  switch (action.type) {
    case 'SET_PROMISE_COUNT':
      return { ...state, promiseCount: action.payload };
    case 'SET_VERBIAGE_COUNT':
      return { ...state, verbiageCount: action.payload };
    case 'SET_AVG_UNIQUE_WORDS':
      return { ...state, avgUniqueWordsPerHundred: action.payload };
    case 'SET_AVG_WORDS_PER_SENTENCE':
      return { ...state, avgWordsPerSentence: action.payload };
    case 'SET_MAIN_THEME':
      return { ...state, mainTheme: action.payload };
    case 'SET_MAIN_KEYWORD':
      return { ...state, mainKeyword: action.payload };
    default:
      return state;
  }
}
const GlobalStateContext = createContext<{ state: GlobalState; dispatch: Dispatch<Action> } | null>(null);

export const useGlobalState = () => {
  return useContext(GlobalStateContext);
};

// Create a provider component
interface GlobalStateProviderProps {
  children: React.ReactNode;
}

export const GlobalStateProvider: React.FC<GlobalStateProviderProps> = ({ children }) => {
  const [state, dispatch] = useReducer(globalStateReducer, initialState);
  return <GlobalStateContext.Provider value={{ state, dispatch }}>{children}</GlobalStateContext.Provider>;
};
